import { CompanyResult, CompanySearch } from "@/types/Company";
import { customBaseQuery } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

// export interface GetMissingActualData {
//   overall_total: number;
//   company_wise: {
//     company_id: number;
//     company_name: string;
//     total: number;
//     marketplaces:[],
//   }[];
// }
export interface MarketplaceData {
  marketplace: string;
  total: number;
}

export interface CompanyWiseData {
  company_id: number;
  company_name: string;
  total: number;
  marketplaces: MarketplaceData[];
}

export interface MissingTrackingResponse {
  overall_total: number;
  marketplace_wise: MarketplaceData[];
  company_wise: CompanyWiseData[];
}

export interface MissingStockResponse {
  total: number;
  marketplace_wise: MarketplaceData[];
  company_wise: CompanyWiseData[];
}

export interface UnassignSummaryResponse {
  overall_total: number;
  marketplace_wise: {
    marketplace: string;
    total: number;
  }[];
  company_wise: {
    company_id: number;
    company_name: string;
    total: number;
    marketplaces: {
      marketplace: string;
      total: number;
    }[];
  }[];
}


export const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Company"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCompanies: builder.query<any, void>({
      query: () => `/company`,
      providesTags: ["Company"],
    }),
    searchCompany: builder.query<CompanyResult, CompanySearch>({
      query: (input) => ({
        url: `/company/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["Company"],
    }),
    getAllCompanies: builder.query<any, void>({
      query: () => `/company`,
      providesTags: ["Company"],
    }),
    getCompanyById: builder.query<any, any>({
      query: (id) => `/company/${id}`,
      providesTags: ["Company"],
    }),
    getCompanyUserById: builder.query<any, void>({
      query: () => `/company`,
      providesTags: ["Company"],
    }),
    getCompanyMarketplace: builder.query<any, string>({
      query: (id) => `/company/marketplace/${id}`,
      providesTags: ["Company"],
    }),
    createCompany: builder.mutation<void, any>({
      query: (input) => ({
        url: `/company`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["Company"],
    }),
    updateCompany: builder.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/company/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    deleteCompany: builder.mutation<any, number>({
      query: (id) => ({
        url: `/company/${id}`,
        method: "DELETE",
      }),
    }),
    getLoggedInUser: builder.query<any, void>({
      query: () => ({
        url: `/user/auth/me`,
        method: "GET",
      }),
      providesTags: ["Company"],
    }),
    updateShowTour: builder.mutation<any, void>({
      query: () => ({
        url: `/user/auth/update-show-tour`,   // backend endpoint
        method: "PUT",
        body: {
          show_tour: true,
        },
      }),
      invalidatesTags: ["Company"],
    }),
    getMissingActualReturn: builder.query<MissingTrackingResponse, void>({
      query: () => ({
        url: `/user/auth/actual-return/missing`,
        method: "GET",
      }),
    }),
    getMissingstock: builder.query<MissingStockResponse, void>({
      query: () => ({
        url: `/user/auth/missing_stock_count`,
        method: "GET",
      }),
    }),
    getUnassignSummary: builder.query<UnassignSummaryResponse, void>({
      query: () => ({
        url: `/user/auth/unassign-summary`,   // your backend endpoint
        method: "GET",
      }),
    }),

    // searchCompany: builder.query<companySearchResult, companySearch>({
    //   query: (input) => ({
    //     url: `/message/search`,
    //     method: "POST",
    //     body: { ...input, export: false },
    //   }),
    //   providesTags: ["Company"],
    // }),
  })
});

export const {
  useLazyGetCompaniesQuery,
  useSearchCompanyQuery,
  useGetAllCompaniesQuery,
  useGetCompanyByIdQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useLazyGetCompanyUserByIdQuery,
  useGetCompanyUserByIdQuery,
  useLazyGetCompanyMarketplaceQuery,
  useGetCompanyMarketplaceQuery,
  useGetLoggedInUserQuery,
  useUpdateShowTourMutation,
  useGetMissingActualReturnQuery,
  useGetMissingstockQuery,
  useGetUnassignSummaryQuery

} = companyApi;
